"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripPriceAndConditionsOutput = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class TripPrice {
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPrice.prototype, "amount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPrice.prototype, "amountWithTax", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripPrice.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPrice.prototype, "vatAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPrice.prototype, "vatRate", void 0);
class TripPriceDetail {
}
__decorate([
    (0, class_transformer_1.Type)(() => TripPrice),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", TripPrice)
], TripPriceDetail.prototype, "price", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripPriceDetail.prototype, "calculationWithVars", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripPriceDetail.prototype, "calculation", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPriceDetail.prototype, "surge", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPriceDetail.prototype, "receptionPriceWithTax", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPriceDetail.prototype, "tollPriceWithTax", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], TripPriceDetail.prototype, "markup", void 0);
class TripPriceGrid {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripPriceGrid.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripPriceGrid.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPriceGrid.prototype, "base", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPriceGrid.prototype, "perMinute", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPriceGrid.prototype, "perKm", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPriceGrid.prototype, "minimum", void 0);
class TripPenaltyPrice {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripPenaltyPrice.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPenaltyPrice.prototype, "amount", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPenaltyPrice.prototype, "minimumPrice", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPenaltyPrice.prototype, "maximumPrice", void 0);
class TripPriceConditionDetail {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripPriceConditionDetail.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripPriceConditionDetail.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPriceConditionDetail.prototype, "freeCancellationPeriodAfterBooking", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPriceConditionDetail.prototype, "freeCancellationPeriodBeforeTrip", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPriceConditionDetail.prototype, "freeWaitingTime", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPriceConditionDetail.prototype, "waitingPrice", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => TripPenaltyPrice),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", TripPenaltyPrice)
], TripPriceConditionDetail.prototype, "lateCancellationPriceDetail", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPriceConditionDetail.prototype, "lateCancellationPrice", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => TripPenaltyPrice),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", TripPenaltyPrice)
], TripPriceConditionDetail.prototype, "noShowPriceDetail", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPriceConditionDetail.prototype, "noShowPrice", void 0);
class TripLinkDetail {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripLinkDetail.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripLinkDetail.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripLinkDetail.prototype, "price", void 0);
class TripPriceAndCondition {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripPriceAndCondition.prototype, "panelKey", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => TripPriceDetail),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", TripPriceDetail)
], TripPriceAndCondition.prototype, "priceDetail", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => TripPriceGrid),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", TripPriceGrid)
], TripPriceAndCondition.prototype, "priceGridDetail", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => TripPriceConditionDetail),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", TripPriceConditionDetail)
], TripPriceAndCondition.prototype, "priceConditionDetail", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => TripLinkDetail),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", TripLinkDetail)
], TripPriceAndCondition.prototype, "linkDetail", void 0);
class TripPriceAndConditionsOutput {
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripPriceAndConditionsOutput.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", TripPriceAndCondition)
], TripPriceAndConditionsOutput.prototype, "passengerPriceAndCondition", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", TripPriceAndCondition)
], TripPriceAndConditionsOutput.prototype, "driverPriceAndCondition", void 0);
exports.TripPriceAndConditionsOutput = TripPriceAndConditionsOutput;
